require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-kansenkaart-steenbergen.json") })
        }
      }, "path---projecten-kansenkaart-steenbergen");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-kansenkaart-steenbergen!./.cache/json/projecten-kansenkaart-steenbergen.json
// module id = 422
// module chunks = 231608221292675